module.exports = "/static/media/cok.4cb55ab5.svg";